import React from "react";
import { Button, Col, Offcanvas, Row } from "react-bootstrap";

import EditableDetail from "../../utils/EditableDetail";
import SpecialtySelect from "../../utils/SpecialtySelect";
import UsStateMultiSelect from "../../utils/UsStateMultiSelect";
import { ProviderAvatar } from "./ProviderHeader";
import { PanelField } from "../header/HeaderParts";

const ProviderEditPanel = ({
  show,
  data,
  localData,
  onValueChanged,
  onSave,
  onCancel,
  newProfilePhotoName,
  onProfilePhotoAdded,
  forceSpecialtyRefresh,
  selectedSpecialties,
  onSpecialtiesChanged,
  supervisingProviderSelect,
  onSupervisingProviderStatesChanged,
}) => {
  return (
    <Offcanvas show={show} onHide={onCancel} placement="end" className="provider-edit-panel">
      <Offcanvas.Header closeButton>
        <div>
          <Offcanvas.Title as="h5" className="mb-0">Edit {data.formattedName}</Offcanvas.Title>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex align-items-center mb-3">
          <ProviderAvatar data={data} size={56} />
          <div className="ms-3">
            <div className="fw-bold">Photo</div>
            <label className="ph-upload-link">
              {newProfilePhotoName != null ? newProfilePhotoName : (data.photoUrl ? "Change photo" : "Upload photo")}
              <input type="file" accept="image/*" hidden onChange={onProfilePhotoAdded} />
            </label>
          </div>
        </div>

        <Row>
          <Col><PanelField label="First name"><EditableDetail originalValue={localData.firstName} width="100%" name="firstName" onValueChanged={onValueChanged} /></PanelField></Col>
          <Col><PanelField label="Middle name"><EditableDetail originalValue={localData.middleName} width="100%" name="middleName" onValueChanged={onValueChanged} /></PanelField></Col>
          <Col><PanelField label="Last name"><EditableDetail originalValue={localData.lastName} width="100%" name="lastName" onValueChanged={onValueChanged} /></PanelField></Col>
        </Row>
        <Row>
          <Col><PanelField label="Credentials"><EditableDetail originalValue={localData.credentials} width="100%" name="credentials" onValueChanged={onValueChanged} /></PanelField></Col>
          <Col><PanelField label="Nickname"><EditableDetail originalValue={localData.nickname} width="100%" name="nickname" onValueChanged={onValueChanged} /></PanelField></Col>
        </Row>
        <div className="mb-3">
          <EditableDetail originalValue={localData.pcp} name="pcp" inputType="switch" placeholder="PCP" onValueChanged={onValueChanged} />
        </div>

        <PanelField label="Specialties">
          <SpecialtySelect path="provider" forceRefresh={forceSpecialtyRefresh} handleSpecialtiesChanged={onSpecialtiesChanged} selectedSpecialties={selectedSpecialties} />
        </PanelField>

        <Row>
          <Col><PanelField label="Cell phone"><EditableDetail originalValue={localData.phone1} width="100%" mask="(999) 999-9999" name="phone1" onValueChanged={onValueChanged} /></PanelField></Col>
          <Col><PanelField label="Pager"><EditableDetail originalValue={localData.pager} width="100%" mask="(999) 999-9999" name="pager" onValueChanged={onValueChanged} /></PanelField></Col>
        </Row>
        <PanelField label="Work email"><EditableDetail originalValue={localData.email1} width="100%" name="email1" onValueChanged={onValueChanged} /></PanelField>
        <PanelField label="Admin CC email"><EditableDetail originalValue={localData.adminEmail} width="100%" name="adminEmail" onValueChanged={onValueChanged} /></PanelField>

        {localData.canHaveSupervising &&
          <PanelField label="Supervising provider(s)">
            {supervisingProviderSelect}
            {(localData.supervisingProviders || []).length > 0 &&
              <div className="mt-2">
                {localData.supervisingProviders.slice().sort((a, b) => (a.name || "").localeCompare(b.name || "")).map((provider) =>
                  <div key={provider.id} className="mb-2">
                    <div className="small">{provider.name}</div>
                    <UsStateMultiSelect
                      values={provider.states}
                      onValuesChanged={(states) => onSupervisingProviderStatesChanged(provider.id, states)}
                    />
                  </div>
                )}
              </div>
            }
          </PanelField>
        }

        <PanelField label="Notes">
          <EditableDetail originalValue={localData.notes} width="100%" name="notes" inputType="textarea" onValueChanged={onValueChanged} />
        </PanelField>
      </Offcanvas.Body>
      <div className="provider-edit-panel-footer">
        <Button variant="outline-secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="primary" onClick={onSave}>Save changes</Button>
      </div>
    </Offcanvas>
  );
};

export default ProviderEditPanel;
